import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function O() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');

    return (
        <section className={`shp2-detail-O shp2-detail-section ${css['shp2-detail-O']}`}>
            <h2 className="title">{t('secO_title')}</h2>
            <div className="boxs">
                <div className="box-1 box">
                    <p className="box-text">{t('secO_box1_text')}</p>
                    <div className="box-img">
                        <EFPicture src="/responsive/picture/smart-home-panel-2/launch/13_1.png" alt={t('secO_box1_text')} />
                    </div>
                </div>
                <div className="box-small">
                    <div className="box-2 box">
                        <p className="box-text">{t('secO_box2_text')}</p>
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/14_2.png" alt={t('secO_box2_text')} />
                        </div>
                    </div>
                    <div className="box-3 box">
                        <p className="box-text">{t('secO_box3_text')}</p>
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/14_3.png" alt={t('secO_box3_text')} />
                        </div>
                    </div>
                    <div className="box-4 box">
                        <p className="box-text">{t('secO_box4_text')}</p>
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/14_4.png" alt={t('secO_box4_text')} />
                        </div>
                    </div>
                    <div className="box-5 box">
                        <p className="box-text">{t('secO_box5_text')}</p>
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/14_5.png" alt={t('secO_box5_text')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
